import { t } from '../../../strings/i18n';
import { length, required } from '../../../xform';
const validateBankName = (apiMachineRef) => (routingNumber) => {
    return new Promise((resolve, reject) => {
        const subscription = apiMachineRef.subscribe((state) => {
            /*
             * It's important that `apiMachine` resets the state back to `bankName.idle`.
             * Otherwise, the next time this validator is invoked, it will assume that the
             * bank name query is resolved even before it attempts to call the API
             */
            if (state.matches('bankName.resolved')) {
                const { bankName, validAccount } = state.context.bankNameQueryResult.data || {};
                if (bankName || validAccount) {
                    resolve();
                }
                else {
                    reject(new Error(t('errors.invalidRoutingNumber')));
                }
                if (subscription) {
                    subscription.unsubscribe();
                }
            }
        });
        apiMachineRef.send({
            type: 'FETCH_BANK_NAME',
            routingNumber
        });
    });
};
export const ROUTING_NUMBER_INPUT_NAME = 'routingNumber';
const routingNumberConfig = (apiMachineRef) => [
    ROUTING_NUMBER_INPUT_NAME,
    undefined,
    'ENABLED',
    [
        required(t('errors.routingNumberRequired')),
        length(t('errors.routingNumberMust9Digits'), 9),
        validateBankName(apiMachineRef)
    ]
];
export default routingNumberConfig;
